/**
 * Telas operacionais com SSE: desliga refetch automático ao focar a aba do navegador.
 * A atualização ao voltar à tela continua via SSE e/ou listener `visibilitychange`.
 */
export const OPERATIONAL_QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
} as const;

/** Prefixos de queryKey usados no Dashboard (setQueryDefaults no provider). */
export const DASHBOARD_QUERY_KEY_PREFIXES = [
  "producao-resumo",
  "producao-usuarios",
  "montagem-resumo",
  "montagem-usuarios",
  "entrega-resumo",
  "entrega-usuarios",
  "bordeiro-resumo-dashboard",
  "fila-estatisticas",
  "dashboard-origem-pizzas",
  "lojas",
] as const;
